module.exports = __webpack_public_path__ + "img/stop.2238765e.svg";